import { SrsSearch } from "../../classes/srs-search.abstract";

export class HideSearch extends SrsSearch {
  search() {}
  autocomplete() {
    return null;
  }
}
